export const hasAdvisoryAii = (categoryScores) =>
  categoryScores.AII !== null && categoryScores.AII !== undefined;
